// @flow
import * as React from 'react'
import { Row, Col, config, Hidden } from 'react-awesome-styled-grid'
import { colors } from '@components/shared/colors'
import styled from 'styled-components'
import type { BlogPostType } from '../../services/contentfulPosts'
import CategoryPillButton from '@components/blog/CategoryPillButton'
import { contentfulLoader } from '../../services/images'
import { FadeInImage } from '@components/shared/FadeInImage'
import { LinkWithUtms } from '../../actions/navigationActions'

type PropsType = {
  blog: BlogPostType
}

export default function BlogSummary (props: PropsType): React.Node {
  const { blog } = props
  const categories = (blog.categories || []).map((cat: any, index: number): React.Node => <CategoryPillButton key={`${index}-blog-summary`} category={cat} />)

  if (blog.slug.includes('placeholder')) {
    return null
  }

  return (
    <RowHover>
      <Hidden xs={true} sm={true}>
        <Col xl={2} lg={3} md={2}>
          <ImageContainer>
            <LinkWithUtms pathname={`/blog/${blog.slug}`}>
              <PostImage>
                {blog.postPhoto && <FadeInImage
                  loader={contentfulLoader}
                  src={blog.postPhoto.file.url}
                  width={blog.postPhoto.file.details.image.width}
                  height={blog.postPhoto.file.details.image.height}
                />}
              </PostImage>
            </LinkWithUtms>
          </ImageContainer>
        </Col>
      </Hidden>
      <Col xl={9} lg={9} md={5} sm={6} xs={4} justify={'center'}>
        <ContentContainer>
          <Hidden xl={true} lg={true} md={true}>
            <ImageContainer>
              <LinkWithUtms pathname={`/blog/${blog.slug}`}>
                <PostImage>
                  {blog.postPhoto && <FadeInImage
                    loader={contentfulLoader}
                    src={blog.postPhoto.file.url}
                    width={blog.postPhoto.file.details.image.width}
                    height={blog.postPhoto.file.details.image.height}
                  />}
                </PostImage>
              </LinkWithUtms>
            </ImageContainer>
          </Hidden>
          <CategoryContainer>
            {categories}
          </CategoryContainer>
          <LinkWithUtms pathname={`/blog/${blog.slug}`}>
            <ClickableTitle>{blog.title}</ClickableTitle>
          </LinkWithUtms>
          <Hidden xs={true} sm={true}>
            <DateContainer>
              {blog.date}
            </DateContainer>
          </Hidden>
        </ContentContainer>
      </Col>
      <Col xl={12} lg={12} sm={8} xs={4} justify={'center'}>
        <Hr size={1}/>
      </Col>
    </RowHover>
  )
}
const ContentContainer = styled.div`
  ${(props: any): string => config(props).media.md`
    width: 100%;
    margin-left: 54px;
  `}

`
const ImageContainer = styled.div`
  width: 187px;
  border-radius: 10px;
  overflow: hidden;
`
const PostImage = styled.div`
  width: 187px;
  cursor: pointer;
  img {
    transition: transform .5s ease;
  }
`
const ClickableTitle = styled.div`
  text-decoration: none;
  font-family: 'Queens Condensed Light';
  font-size: 28px;
  line-height: 33.6px;
  cursor: pointer;
  color: ${colors.sand};

  ${(props: any): string => config(props).media.md`
    font-size: 23px;
    line-height: 25px;
  `}

  ${(props: any): string => config(props).media.lg`
    font-size: 28px;
    line-height: 33.6px;
  `}
`
const CategoryContainer = styled.div`
  margin-bottom: 7px;
  margin-top: 20px;

  ${(props: any): string => config(props).media.md`
    margin-bottom: 10px;
    margin-top: 0px;
  `}
`
const DateContainer = styled.div`
  margin-top: 20px;
  font-family: 'Good Sans Regular';
  font-size: 12px;
  color: ${colors.sand}
`

const Hr = styled.hr`
  height: 1px;
  background-color:${colors.sand};
  border: none;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 25px;

  ${(props: any): string => config(props).media.md`
    margin-bottom: 21px;
    margin-bottom: 21px;
  `}

  ${(props: any): string => config(props).media.lg`
    margin-top: 25px;
    margin-bottom: 25px;
  `}

`

const RowHover = styled(Row)`
  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`
